define(
  'loadMap',[
  ],
  () => {
    'use strict';

    const loadMap = function (configuration) {
      document.querySelector('[data-static-map]').addEventListener('touchend', function loadMapScripts() {
        const element = this;
        if (element) {
          require(['mapInitializer'], (mapInitializer) => {
            mapInitializer.init(configuration);
            element.click();
          });
          element.removeEventListener('touchend', loadMapScripts);
        }
      });
    };

    return {
      init: loadMap
    };
  }
);

